module.exports = __webpack_public_path__ + "img/o2o05.71d8c128.png";